"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Notification = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");
var _moment = _interopRequireDefault(require("moment"));
var _Notification = require("./Notification.styled");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var Notification = exports.Notification = function Notification(_ref) {
  var type = _ref.type,
    delay = _ref.delay,
    message = _ref.message,
    countDownTargetDate = _ref.countDownTargetDate,
    _ref$isDismissible = _ref.isDismissible,
    isDismissible = _ref$isDismissible === void 0 ? true : _ref$isDismissible,
    linkMessage = _ref.linkMessage,
    onClick = _ref.onClick,
    _ref$onCloseCallback = _ref.onCloseCallback,
    onCloseCallback = _ref$onCloseCallback === void 0 ? null : _ref$onCloseCallback;
  var _useState = (0, _react.useState)(true),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    visible = _useState2[0],
    setVisible = _useState2[1];
  var defaultCountDown = !countDownTargetDate ? '' : (0, _moment["default"])(countDownTargetDate).from((0, _moment["default"])(), true);
  var _useState3 = (0, _react.useState)(defaultCountDown),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    countDownDisplay = _useState4[0],
    setCountDownDisplay = _useState4[1];
  (0, _react.useEffect)(function () {
    if (countDownTargetDate) {
      var interval = setInterval(function () {
        setCountDownDisplay((0, _moment["default"])().from((0, _moment["default"])(countDownTargetDate), true));
      }, 1000);
    }
  }, []);
  var handleClose = function handleClose() {
    setVisible(false);
    if (onCloseCallback) {
      onCloseCallback();
    }
  };
  (0, _react.useEffect)(function () {
    if (delay) {
      var timer = setTimeout(function () {
        setVisible(false);
      }, delay);
      return function () {
        return clearTimeout(timer);
      };
    }
  }, [delay]);
  var primaryColor = '#C2E8D8';
  var secondaryColor = '#185037';
  var borderColor = '#185037';
  switch (type) {
    case 'alert':
      primaryColor = '#FFEA7F';
      secondaryColor = '#33373D';
      borderColor = '#B08800';
      break;
    case 'warning':
      primaryColor = '#F5C0BA';
      secondaryColor = '#9B2012';
      borderColor = '#9B2012';
      break;
    case 'info':
      primaryColor = '#F0F2F6';
      secondaryColor = '#33373D';
      borderColor = '#33373D';
      break;
    default:
      primaryColor;
      secondaryColor;
      borderColor;
      break;
  }
  var iconNode = _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    "data-testid": "notification-icon",
    icon: _freeSolidSvgIcons.faInfoCircle
  });
  var linkNode = linkMessage && onClick ? _react["default"].createElement(_Notification.NotificationLink, {
    secondaryColor: secondaryColor,
    onClick: onClick
  }, linkMessage) : null;
  var closeNode = isDismissible && _react["default"].createElement(_Notification.NotificationCloseButton, null, _react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    "data-testid": "notification-close",
    icon: _freeSolidSvgIcons.faTimesCircle,
    onClick: handleClose
  }));
  var countDownNode = !countDownTargetDate ? null : countDownDisplay;
  return visible ? _react["default"].createElement(_Notification.NotificationWrapper, (0, _extends2["default"])({
    role: "alert"
  }, {
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    borderColor: borderColor
  }), iconNode, _react["default"].createElement(_Notification.NotificationText, null, message, " ", countDownNode), linkNode, closeNode) : null;
};
Notification.propTypes = {
  type: _propTypes["default"].oneOf(['success', 'alert', 'warning', 'info']),
  message: _propTypes["default"].string,
  linkMessage: _propTypes["default"].string,
  isDismissible: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  delay: _propTypes["default"].number,
  onCloseCallback: _propTypes["default"].func
};